import { useEffect } from 'react';
import {
    AltenarService,
    createAltenarSessionRequest,
    setAltenarStoreEvent,
    useAltenarStore
} from "../../../entities/altenar-service";
import {ProjectSettings} from "../../../../config";
import useScript from "../../../../hooks/useScript";
import {useTypedSelector} from "../../../../hooks/useTypedRedux";
import {selectUserId} from "../../../../redux/selectors/appSelector";

interface IInitAltenarProps {
    culture: string;
}

export const useInitAltenar = (props: IInitAltenarProps) => {
    const { culture } = props;
    const altenarStore = useAltenarStore();
    const settings = ProjectSettings;
    const status = useScript(settings.services().ALTENAR?.WSDK_URL || '' );
    const isAuth = !!useTypedSelector(selectUserId);
    const initAltenar = (token: string) => {
        setAltenarStoreEvent(new AltenarService(token ?? '', culture));
    };

    const initAuthAltenar = () => {
        if (!isAuth) {
            initAltenar('');
        } else {
            createAltenarSessionRequest()
                .then((x) => x.token)
                .then((token) => {
                    initAltenar(token);
                });
        }
    };

    useEffect(() => {
        if (status !== 'ready') return;
        if (!altenarStore) {
            initAuthAltenar();
        } else {
            createAltenarSessionRequest()
                .then((x) => x.token)
                .then((token) => {
                    altenarStore.authAltenar(token);
                });
        }
    }, [isAuth, status]);
};
